import { NavItem, NavSection } from '@olv/ui-shared/models/nav-section.model';
import { Resources, Scopes } from '@olv/ui-shared/models/settlement-permissions.model';

const REPORTS_NAV_ITEM: NavItem = {
  label: 'Reports',
  route: '/reports',
  icon: 'bar_chart',
  permission: { resource: Resources.Reports, scope: Scopes.Access },
};

const TASKS_NAV_SECTION: NavSection = {
  label: 'Tasks',
  permission: [
    { resource: Resources.Tasks, scope: Scopes.Access },
    { resource: Resources.Tasks, scope: Scopes.History },
  ],
  items: [
    {
      label: 'Pending Tasks',
      route: '/tasks',
      icon: 'checklist',
      exact: true,
      badge: 'pendingTasks',
      permission: { resource: Resources.Tasks, scope: Scopes.Access },
    },
    {
      label: 'Task History',
      route: '/tasks/history',
      icon: 'history',
      permission: { resource: Resources.Tasks, scope: Scopes.History },
    },
  ],
};

export const SETTLEMENT_NAV_SECTIONS: NavSection[] = [
  {
    label: 'Dashboard',
    permission: [
      { resource: Resources.Dashboard, scope: Scopes.Access },
      { resource: Resources.Merchants, scope: Scopes.Access },
    ],
    items: [
      {
        label: 'System',
        route: '/dashboard',
        icon: 'home',
        exact: true,
        permission: { resource: Resources.Dashboard, scope: Scopes.Access },
      },
      {
        label: 'Merchants',
        route: '/merchants',
        image: 'shared-assets/icons/merchant.svg',
        permission: { resource: Resources.Merchants, scope: Scopes.Access },
      },
    ],
  },
  {
    label: 'Operations',
    permission: [
      { resource: Resources.Staking, scope: Scopes.Access },
      { resource: Resources.Sweeping, scope: Scopes.Access },
      { resource: Resources.WalletLifecycle, scope: Scopes.Access },
    ],
    items: [
      {
        label: 'Staking',
        route: '/staking',
        icon: 'layers',
        permission: { resource: Resources.Staking, scope: Scopes.Access },
      },
      {
        label: 'Sweeping',
        route: '/sweeping',
        icon: 'cleaning_services',
        permission: { resource: Resources.Sweeping, scope: Scopes.Access },
      },
      {
        label: 'Wallet Lifecycle',
        route: '/wallet-lifecycle',
        icon: 'wallet',
        permission: { resource: Resources.WalletLifecycle, scope: Scopes.Access },
      },
    ],
  },
  {
    label: 'Settings',
    permission: [
      { resource: Resources.Configuration, scope: Scopes.Access },
      { resource: Resources.Accounts, scope: Scopes.Access },
    ],
    items: [
      {
        label: 'Configuration',
        route: '/configuration',
        icon: 'settings',
        permission: { resource: Resources.Configuration, scope: Scopes.Access },
      },
      {
        label: 'Account Management',
        route: '/account-management',
        icon: 'person',
        permission: { resource: Resources.Accounts, scope: Scopes.Access },
      },
    ],
  },
  {
    label: 'Analytics',
    permission: { resource: Resources.Reports, scope: Scopes.Access },
    items: [
      REPORTS_NAV_ITEM,
      {
        label: 'Maintenance',
        route: '/maintenance',
        icon: 'build',
        permission: [
          { resource: Resources.EthereumBlockchain },
          { resource: Resources.TronBlockchain },
          { resource: Resources.BscBlockchain },
        ],
      },
    ],
  },
  TASKS_NAV_SECTION,
];

export const MERCHANT_NAV_SECTIONS: NavSection[] = [
  {
    label: 'Dashboard',
    permission: { resource: Resources.Dashboard, scope: Scopes.Access },
    items: [
      {
        label: 'Dashboard',
        route: '/dashboard',
        icon: 'home',
        exact: true,
        permission: { resource: Resources.Dashboard, scope: Scopes.Access },
      },
    ],
  },
  {
    label: 'Settings',
    permission: { resource: Resources.Accounts, scope: Scopes.Access },
    items: [
      {
        label: 'User Management',
        route: '/account-management',
        icon: 'person',
        permission: { resource: Resources.Accounts, scope: Scopes.Access },
      },
    ],
  },
  {
    label: 'Analytics',
    permission: { resource: Resources.Reports, scope: Scopes.Access },
    items: [REPORTS_NAV_ITEM],
  },
  TASKS_NAV_SECTION,
];
